import BaseModel from '../base/BaseModel.model';
import { BudgetItemCalculation } from '@/enums/BudgetItemCalculation';
export default class BudgetSubItem extends BaseModel {

   public name?: string;
   public budgetItemId?:number | null;
   public budgetItemCalculation?: BudgetItemCalculation;

   constructor(){
       super();
       this.init();
   }

    init(){
       this.name = "";
       this.budgetItemId = null;
       this.budgetItemCalculation = BudgetItemCalculation.UNIDADXCOSTOUNITARIO;
    }

}